/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { StoryCard } from "../basic/story-card.js";
import { CollectionName } from "../atoms/collection-name/index.js";
import { AdService } from "../ad-service";
import { wrapCollectionLayout } from "@quintype/components";
import { isEager, getRowMetadata } from "../../utils";

import "./l-shape-one-widget.m.css";

function LShapeOneWidgetLayoutBase({ collection, stories, config, associatedMetadata, index }) {
  const primarStoryCardConfig = {
    section: true,
    subheadline: true,
    image: true,
    imageAspectRatio: [4, 3],
    imageWidth: [400, 820]
  };
  const storyListConfig = {
    image: true,
    imageWidth: [400, 380]
  };
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const { show_collection_title: collectionName = true } = pbAheadConfig;

  return (
    <div styleName="component-wrapper" data-test-id="l-shape-grid-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <div styleName="first-row">
        <div styleName="feature-story">
          <StoryCard
            eager={isEager(index, true)}
            hideSectionName={true}
            story={stories[0]}
            config={primarStoryCardConfig}
            type="imageBackground"
          />
        </div>
        <div className="app-ad app-ad--vertical">
          <AdService
            adtype="Vertical-Ad"
            layoutName="LShapeOneWidget"
            collectionSlug={collection.slug}
            slotId={`LShapeOneWidget-${index}A`}
          />
        </div>
      </div>

      <div styleName="second-row">
        {stories.slice(1, 4).map(story => {
          return (
            <div key={story.id}>
              <StoryCard hideSectionName={true} config={storyListConfig} story={story} />
            </div>
          );
        })}
      </div>
      <div className="app-ad app-ad--horizontal">
        <AdService
          adtype="Horizontal-Ad"
          layoutName="LShapeOneWidget"
          collectionSlug={collection.slug}
          slotId={`LShapeOneWidget-${index}B`}
        />
      </div>
    </div>
  );
}

LShapeOneWidgetLayoutBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const LShapeOneWidget = wrapCollectionLayout(LShapeOneWidgetLayoutBase);

LShapeOneWidget.storyLimit = 4;
